// extracted by mini-css-extract-plugin
export default {"uniqueContainer":"ManageContestsParentComponent_uniqueContainer__TVqvd","uniqueContentArea":"ManageContestsParentComponent_uniqueContentArea__7Rq1f"};